import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { client } from '../../utils/trpc';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  scrapeId: number;
};
export const RenderRawScrapeModal = t0 => {
  const $ = _c(13);
  const {
    scrapeId,
    closeHandler
  } = t0;
  let t1;
  if ($[0] !== scrapeId) {
    t1 = {
      queryKey: ["rawScrape", scrapeId],
      queryFn: () => unwrapFromResult(client.bots.getRawScrape.query({
        scrapeId
      }))
    };
    $[0] = scrapeId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: rawScrape,
    isLoading,
    isError,
    error
  } = useQuery(t1);
  let t2;
  if ($[2] !== closeHandler) {
    t2 = <ModalHeader closeHandler={closeHandler}>Raw Scrape</ModalHeader>;
    $[2] = closeHandler;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== error || $[5] !== isError || $[6] !== isLoading || $[7] !== rawScrape) {
    t3 = <ModalContent>{isLoading ? <p className="text-sm text-textSecondary">Loading raw scrape…</p> : isError ? <p className="text-sm text-red-400">Failed to load raw scrape{error instanceof Error ? `: ${error.message}` : ""}.</p> : rawScrape ? <pre className="overflow-x-auto whitespace-pre-wrap rounded-lg bg-background-primary p-4 font-mono text-xs text-green-200">{rawScrape}</pre> : <p className="text-sm text-textSecondary">No raw scrape data available.</p>}</ModalContent>;
    $[4] = error;
    $[5] = isError;
    $[6] = isLoading;
    $[7] = rawScrape;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== closeHandler || $[10] !== t2 || $[11] !== t3) {
    t4 = <Modal closeHandler={closeHandler}>{t2}{t3}</Modal>;
    $[9] = closeHandler;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};